module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.3/frontend/_next/static/images/rectangle-1-a135397817b39267dca02ffeb4884b29.png";